export default __webpack_public_path__ + "static/media/ap-logo.4b8f6c96.svg";